import { render, staticRenderFns } from "./VerticalNavMenuFooter.vue?vue&type=template&id=3acb614c&"
import script from "./VerticalNavMenuFooter.vue?vue&type=script&lang=js&"
export * from "./VerticalNavMenuFooter.vue?vue&type=script&lang=js&"
import style0 from "./VerticalNavMenuFooter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../landing-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports